import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrErrorMessage, {
  SR_ERROR_MESSAGE_THEME_ORANGE,
} from 'client/components/SrErrorMessage/SrErrorMessage';
import SrInfoTile, { SR_INFO_TILE_THEME_ADMIN_GREY } from 'client/components/SrInfoTile/SrInfoTile';

const SrApplicationAssemblyLineStepSSN = ({ assemblyLine, householdApplication }) => {
  const status = SrApplicationAssemblyLineStepSSN.getStatus({
    householdApplication,
    assemblyLine,
  });
  const tenantAlertReport = assemblyLine.tenantAlertReports.find((tar) => {
    return tar.userId === householdApplication.userId;
  });

  const ssnDom = (
    <SrBox display="inlineBlock">
      <SrFlex border="1px solid #EAEBEC" borderRadius="8px" padding="16px">
        <SrInfoTile
          theme={SR_INFO_TILE_THEME_ADMIN_GREY}
          label="Did the SSN/ITIN number clear?"
          value={
            householdApplication.ssn && tenantAlertReport
              ? 'Yes'
              : !householdApplication.ssn
              ? 'Applicant doesn’t have SSN/ITIN'
              : 'No Tenant Report Found'
          }
          valueColor={
            status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED
              ? '#00A238'
              : status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED
              ? '#E8001D'
              : '#E7711B'
          }
        />
      </SrFlex>
    </SrBox>
  );

  const informationRequiredDom = (
    <SrBox marginTop="22px">
      <SrText
        color="orange300"
        font="greycliff"
        weight="700"
        size="18"
        lineHeight="24px"
        display="block"
      >
        Information Required
      </SrText>
      <SrBox marginTop="8px" maxWidth="468px">
        {!householdApplication.ssn ? (
          <SrErrorMessage theme={SR_ERROR_MESSAGE_THEME_ORANGE}>
            No SSN/ITIN number
            <br />
            Please ask the applicant to provide a valid SSN/ITIN number so we can run a credit and
            background check.
          </SrErrorMessage>
        ) : (
          <SrErrorMessage theme={SR_ERROR_MESSAGE_THEME_ORANGE}>
            Tenant Report
            <br />
            No Tenant Report found for this applicant. Contact your Associate Account Manager for
            assistance.
          </SrErrorMessage>
        )}
        <SrBox marginTop="16px" />
        <SrText color="orange300" font="greycliff" weight="600" size="16" lineHeight="24px">
          Once you've asked the applicant for these changes move on to the next applicant in this
          household.
        </SrText>
      </SrBox>
    </SrBox>
  );

  return (
    <SrBox minWidth="300px">
      {ssnDom}
      {status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS && informationRequiredDom}
    </SrBox>
  );
};

SrApplicationAssemblyLineStepSSN.propTypes = {
  assemblyLine: PropTypes.object.isRequired,
  householdApplication: PropTypes.object.isRequired,
};

SrApplicationAssemblyLineStepSSN.stepTitle = 'SSN/ITIN';
SrApplicationAssemblyLineStepSSN.displayName = 'SrApplicationAssemblyLineStepSSN';

SrApplicationAssemblyLineStepSSN.getStatus = ({ householdApplication, assemblyLine }) => {
  const tenantAlertReport = assemblyLine.tenantAlertReports.find((tar) => {
    return tar.userId === householdApplication.userId;
  });
  const qualified = tenantAlertReport && householdApplication.ssn;

  let status = SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS;

  if (!householdApplication.ssn || !tenantAlertReport) {
    status = SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS;
  } else if (qualified) {
    status = SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED;
  } else if (!qualified) {
    status = SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED;
  }

  return status;
};

export default SrApplicationAssemblyLineStepSSN;
